// extracted by mini-css-extract-plugin
export var iframe = "style-mod--iframe--9ebc4";
export var iframeTitle = "style-mod--iframe-title--50cb7";